import { render, staticRenderFns } from "./ModalGroupAppointmentAdd.vue?vue&type=template&id=8ae7e7f2&"
import script from "./ModalGroupAppointmentAdd.vue?vue&type=script&lang=js&"
export * from "./ModalGroupAppointmentAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports